<template>
	<el-alert v-if="show" type="warning" :title="title" :closable="false" show-icon class="mb-3"></el-alert>
</template>

<script>
import { Alert } from "element-ui";

// show: false | true / "phase1" (pos_not_installed) | "phase3" (pos_phase3_not_installed)
export default {
	name: "PosInstallAlert",
	components: { [Alert.name]: Alert },
	props: { show: { type: [Boolean, String], default: false } },
	computed: {
		title() {
			return this.show === "phase3" ? this.$t("pos.not_installed_phase3") : this.$t("pos.not_installed");
		}
	}
};
</script>
